var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { GRID_UNIT } from '../../utilities/grid';
import { Text } from '../Text';
export var StyledChip = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  border-radius: 62px;\n  padding: ", "px ", "px;\n  padding-left: ", "px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: ", "px;\n  border: 1px solid;\n\n  border-color: ", ";\n  background-color: ", ";\n\n  :hover {\n    border-color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  border-radius: 62px;\n  padding: ", "px ", "px;\n  padding-left: ", "px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: ", "px;\n  border: 1px solid;\n\n  border-color: ", ";\n  background-color: ", ";\n\n  :hover {\n    border-color: ", ";\n  }\n"])), GRID_UNIT, GRID_UNIT * 2, function (_a) {
  var hasIcon = _a.hasIcon;
  return hasIcon ? GRID_UNIT : GRID_UNIT * 2;
}, GRID_UNIT, function (_a) {
  var isSelected = _a.isSelected,
    theme = _a.theme;
  return isSelected ? theme.tokens.accent.token.secondary.regular : theme.tokens.interface.neutral.lightest;
}, function (_a) {
  var isSelected = _a.isSelected,
    theme = _a.theme;
  return isSelected ? theme.tokens.accent.token.secondary.regular : theme.tokens.interface.neutral.lightest;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.accent.token.secondary.regular;
});
export var ChipText = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    color: ", ";\n  }\n"], ["\n  && {\n    color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme,
    isSelected = _a.isSelected;
  return isSelected ? theme.tokens.accent.onToken.secondary.regular : theme.tokens.accent.token.secondary.regular;
});
var templateObject_1, templateObject_2;